<template>
  <article class="layout-section -align-side -reverse">
    <figure class="layout-section__figure -reverse" :style="{ backgroundImage }" />

    <section class="layout-section__content">
      <h2 class="layout-section__title">{{ wp.projects.title }}</h2>
      <p>
        {{ wp.projects.text }}
      </p>

      <RouterLink :to="{ name: 'project-index' }" class="button layout-section__cta">
        Explorez nos projets
        <SvgIcon id="action-arrow" />
      </RouterLink>
    </section>
  </article>
</template>

<script>
export default {
  name: 'DonationMore',
  inject: ['wp'],
  computed: {
    backgroundImage() {
      return `url(${this.wp.projects.image})`
    }
  }
}
</script>
